import React, { useState } from "react";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { Image, Col, Form, Button, Row } from "react-bootstrap";
import { TextField, FormControl, Select, InputLabel } from "@material-ui/core";
//import Paper from "@material-ui/core/Paper";
//import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
//import SearchIcon from "@material-ui/icons/Search";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";

export const SuperAdminTopTextSearchIcon = (props) => {
  return (
    <React.Fragment>
      <div className="row super-admin-toptext-searchbar-icon">
        <div className="col-6">
          <div className="col-9 p-0">
            {props.userManagement ? (
              <Form.Control
                type="text"
                placeholder="Search by user name, user id, location"
                onChange={props.onChange}
                value={props.search}
                className="amSearch"
              />
            ) : (
              <Form.Control
                type="text"
                placeholder="Search by name"
                onChange={(e) => props.onChange(e.target.value)}
                value={props.search}
                className="amSearch"
              />
            )}
          </div>
        </div>

        <div className="col-6">
          <div className="d-flex justify-content-end align-items-center">
            <div className="mr-3">
              {/* <FormControl variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">Select date range</InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={""}
                  onChange={() => {}}
                  label="Age"
                >
                  <MenuItem value="">Last 30 days</MenuItem>
                </Select>
              </FormControl> */}

              <FormControl variant="filled" className="enSortSelect">
                <Select
                  value={props.sortByDay}
                  onChange={(e) => props.changeSortByDay(e.target.value)}
                  inputProps={{
                    name: "SortBy",
                  }}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  {sortBy.map((data) => {
                    return (
                      <option
                        value={data.id}
                        defaultValue={props.sortByDay}
                        key={data.id}
                      >
                        {data.title}
                      </option>
                    );
                  })}
                </Select>
                Select Date Range
              </FormControl>
            </div>
            <div className="text-blue f15-500 mr-3">Sort by</div>
            {props.userManagement ? (
              <>
                <FormControl variant="filled" className="enSortSelect">
                  <Select
                    value={props.sortByDay}
                    onChange={(e) => props.changeSortByDay(e.target.value)}
                    inputProps={{
                      name: "SortBy",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {sortBy.map((data) => {
                      return (
                        <option
                          value={data.id}
                          defaultValue={props.sortByDay}
                          key={data.id}
                        >
                          {data.title}
                        </option>
                      );
                    })}
                  </Select>
                </FormControl>
              </>
            ) : (
              <>
                <FormControl variant="filled" className="enSortSelect">
                  <Select
                    value={props.sortBy}
                    //onChange={props.handleChangeCode}
                    onChange={(e) => props.changeSortBy(e.target.value)}
                    inputProps={{
                      name: "SortBy",
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    <option value="a">Name A-Z</option>
                    <option value="d">Name Z-A</option>
                  </Select>
                </FormControl>
              </>
            )}

            <div className="text-blue f15-500 ml-5 mr-3">Filters</div>
            <IconButton className="enDownIcon" onClick={props.handleShowFilter}>
              <Image
                src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                alt="View"
                title="View"
              />
            </IconButton>
          </div>
        </div>
        {props.showFilter && (
          <div className="col-12  mt-3">
            <div className="enWhiteBox mt-3">
              <Form className="row justify-content-between">
                {props.userManagement && (
                  <Col md={5}>
                    Date Range
                    <div
                      className="d-flex justify-content-start"
                      style={{ alignItems: "center" }}
                    >
                      <TextField
                        type="date"
                        variant="outlined"
                        onChange={props.onStartDateChange}
                        value={props.startDate}
                      />
                      &nbsp;To&nbsp;
                      <TextField
                        type="date"
                        variant="outlined"
                        onChange={props.onEndDateChange}
                        value={props.endDate}
                      />
                    </div>
                    <br />
                  </Col>
                )}
                {props.activeDonationType === "order" ||
                props.activeDonationType === "events" ||
                props.activeDonationType === "scan" ? (
                  <React.Fragment>
                    <Col md={5}>
                      <Form.Group>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-Status">
                            Payment Method
                          </InputLabel>
                          <Select
                            value={props.selectedPaymentMethod}
                            onChange={(e) =>
                              props.setSelectedPaymentMethod(e.target.value)
                            }
                            label="Payment"
                            inputProps={{
                              name: "Status",
                              id: "outlined-Status",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {paymentMethod.map((data) => {
                              return (
                                <option value={data.id} key={data.id}>
                                  {data.title}
                                </option>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>

                    <Col md={5}>
                      <Form.Group>
                        <FormControl variant="outlined" className="w-100">
                          <InputLabel htmlFor="outlined-Status">
                            Payment To
                          </InputLabel>
                          <Select
                            value={props.selectedPaymentTo}
                            onChange={(e) =>
                              props.setSelectedPaymentTo(e.target.value)
                            }
                            label="Payment"
                            inputProps={{
                              name: "Status",
                              id: "outlined-Status",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            {props.restaurantData &&
                              props.restaurantData.map((data) => {
                                return (
                                  <option value={data.id} key={data.id}>
                                    {data.title}
                                  </option>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                  </React.Fragment>
                ) : (
                  <> </>
                )}
                {props.activeDonationType === "order" ||
                props.activeDonationType === "scan" ? (
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Status">
                          Order Type
                        </InputLabel>
                        <Select
                          value={props.selectedOrderType}
                          onChange={(e) =>
                            props.setSelectedOrderType(e.target.value)
                          }
                          label="Status"
                          inputProps={{
                            name: "Status",
                            id: "outlined-Status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {orderType.map((data) => {
                            return (
                              <option value={data.id} key={data.id}>
                                {data.title}
                              </option>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                ) : props.activeDonationType === "events" ? (
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Status">
                          Event Type
                        </InputLabel>
                        <Select
                          value={props.selectedOrderType}
                          onChange={(e) =>
                            props.setSelectedOrderType(e.target.value)
                          }
                          label="Status"
                          inputProps={{
                            name: "Status",
                            id: "outlined-Status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {orderType.map((data) => {
                            return (
                              <option value={data.id} key={data.id}>
                                {data.title}
                              </option>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                ) : (
                  <> </>
                )}

                {props.activeDonationType === "referal" ? (
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Status">
                          Referred role
                        </InputLabel>
                        <Select
                          value={props.selectedReferedRole}
                          onChange={(e) =>
                            props.setSelectedReferedRole(e.target.value)
                          }
                          label="Payment"
                          inputProps={{
                            name: "Status",
                            id: "outlined-Status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {referROle.map((data) => {
                            return (
                              <option value={data.id} key={data.id}>
                                {data.title}
                              </option>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                ) : (
                  <> </>
                )}

                {props.type === "report" ? (
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Status">
                          Organization Name
                        </InputLabel>
                        <Select
                          value={props.selectedOrganizationName}
                          onChange={(e) =>
                            props.setSelectedOrganizationName(e.target.value)
                          }
                          label="Payment"
                          inputProps={{
                            name: "Status",
                            id: "outlined-Status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {props.organizationName.map((data) => {
                            return (
                              <option value={data.id} key={data.id}>
                                {data.title}
                              </option>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                ) : (
                  <> </>
                )}
                <Col md={12}>
                  <div className="d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5"
                      onClick={() => props.onClickCancel()}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={() => props.onClickSearch()}
                    >
                      Search
                    </Button>
                  </div>
                </Col>
              </Form>
            </div>
          </div>
        )}
      </div>
      {/* <div className="col-12 super-admin-toptext-searchbar-icon">
        <div className="col-6 p-0">
          <h3>{topText}</h3>
        </div>
        <div className="col-6 p-0 d-flex align-items-center justify-content-end">
          <div className="col-6 p-0">
            <InputBoxComponent
              displayLabel={false}
              controlId="search"
              inputType="search"
              placeHolder="Search"
              name="phoneNumber"
              onChange={onChange}
              value={search}
              inputClassName="input-component-inputfield"
            />
          </div>
          {/* {displayIcon === true ? (
            <div className="super-admin-filter-button">{filter}</div>
          ) : null} *
        </div>
      </div> */}
    </React.Fragment>
  );
};

export const SuperAdminFilter = (props) => {
  return (
    <React.Fragment>
      <div className="row super-admin-toptext-searchbar-icon">
        <div className="col-6">
          <div className="col-9 p-0">
            <Form.Control
              type="text"
              placeholder="Search by offer name and coupon code"
              onChange={props.onChange}
              value={props.search}
              className="amSearch"
            />
          </div>
        </div>
        <div className="col-6">
          <div className="d-flex justify-content-end align-items-center">
            <div className="text-blue f15-500 mr-3">Sort by</div>
            <FormControl variant="filled" className="enSortSelect">
              <Select
                value={props.sortBy}
                onChange={props.handleChangeCode}
                inputProps={{
                  name: "SortBy",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {sortByCode.map((data) => {
                  return (
                    <option value={data.title} key={data.id}>
                      {data.title}
                    </option>
                  );
                })}
              </Select>
            </FormControl>
            <div className="text-blue f15-500 ml-5 mr-3">Filters</div>
            <IconButton className="enDownIcon" onClick={props.handleShowFilter}>
              <Image
                src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                alt="View"
                title="View"
              />
            </IconButton>
          </div>
        </div>
        {props.showFilter && (
          <div className="col-12  mt-3">
            <div className="enWhiteBox mt-3">
              <Form className="row justify-content-between">
                <Col md={5}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Status">Status</InputLabel>
                      <Select
                        value={props.status}
                        onChange={props.handleStatusChange}
                        label="Status"
                        inputProps={{
                          name: "Status",
                          id: "outlined-Status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {statusCode.map((data) => {
                          return (
                            <option value={data.title} key={data.id}>
                              {data.title}
                            </option>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
                <Col md={5}>
                  <Form.Group>
                    <FormControl variant="outlined" className="w-100">
                      <InputLabel htmlFor="outlined-Offer">Offer</InputLabel>
                      <Select
                        value={props.offerType}
                        onChange={props.handleOfferTypeChange}
                        label="Offer"
                        inputProps={{
                          name: "Offer",
                          id: "outlined-Location",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {offerTypes.map((data) => {
                          return (
                            <option value={data.title} key={data.id}>
                              {data.title}
                            </option>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5"
                      onClick={props.cancelClick}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={props.searchClick}
                    >
                      Search
                    </Button>
                  </div>
                </Col>
              </Form>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export const SuperAdminTopSearchIcon = ({
  onChange,
  search,
  filter,
  displayIcon,
}) => {
  return (
    <React.Fragment>
      <div className="col-12 super-admin-toptext-searchbar-icon">
        <div className="col-12 p-0 d-flex align-items-center justify-content-end">
          <div className="col-12 p-0">
            <NewInputText
              displayLabel={false}
              controlId="search"
              inputType="search"
              placeHolder="Search"
              inputLabel="Search"
              name="phoneNumber"
              onChange={onChange}
              value={search}
              inputClassName="input-component-inputfield"
            />
          </div>
          {displayIcon === true ? (
            <div className="super-admin-filter-button">{filter}</div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};
const offerTypes = [
  { id: 0, title: "All" },
  { id: 1, title: "Online" },
  { id: 2, title: "Offline" },
];

const statusCode = [
  { id: 0, title: "All" },
  { id: 1, title: "Active" },
  { id: 2, title: "Inactive" },
];

const sortByCode = [
  { id: 0, title: "Offer Name A-Z" },
  { id: 1, title: "Offer Name Z-A" },
];

const sortBy = [
  { id: 1, title: "Today" },
  { id: 2, title: "Last month" },
  { id: 3, title: "Last 3 months" },
  { id: 4, title: "ALL" },
];

const orderType = [
  { id: 0, title: "Take Away" },
  { id: 1, title: "Curb Side" },
  { id: 3, title: "Dine In" },
];

const paymentMethod = [
  { id: "SCAN_AND_PAY", title: "Scan And Pay" },
  { id: "RAZORPAY", title: "Razor Pay" },
];

const referROle = [
  { id: "User", title: "User" },
  { id: "Vendor", title: "Vendor" },
  { id: "Sales", title: "Sales" },
  { id: "Affiliates", title: "Affiliates" },
  { id: "Partners", title: "Partners" },
];
